import { IroNamRequestStatus } from '@shs-digi-care-monorepo/interfaces';

export const statusList = [
    { description: 'common.status-stepper.request-submitted', values: [IroNamRequestStatus.SUBMITTED] },
    { description: 'common.status-stepper.under-review', values: [IroNamRequestStatus.UNDER_REVIEW] },
    {
        description: 'common.status-stepper.referred-out',
        values: [IroNamRequestStatus.PENDING_CUSTOMER_ACTION, IroNamRequestStatus.REFERRED_OUT]
    },
    { description: 'common.status-stepper.request-resolved', values: [IroNamRequestStatus.CLOSED] }
];
